import { CSSProperties } from "react";

interface DropdownAnchorRect {
    top: number;
    right: number;
    width: number;
}

interface ResizeObserverPort<ElementType> {
    observe: (element: ElementType) => void;
    disconnect: () => void;
}

type ResizeObserverFactory<ElementType> = (onResize: () => void) => ResizeObserverPort<ElementType>;

export const calculateDropdownPosition = (anchor: DropdownAnchorRect, dropdownHeight: number, sidebarOpen: boolean): CSSProperties => ({
    position: "absolute",
    top: anchor.top - dropdownHeight - 4,
    left: anchor.right - (sidebarOpen ? 235 : 20),
    zIndex: 9999,
    width: sidebarOpen ? anchor.width : 250
});

export const observeDropdownSize = <ElementType>(
    element: ElementType,
    updatePosition: () => void,
    createObserver: ResizeObserverFactory<ElementType>
): (() => void) => {
    updatePosition();
    const observer = createObserver(updatePosition);
    observer.observe(element);
    return () => observer.disconnect();
};
